// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../engines/components/BasePopUpLayer";
import O1HD from "../../../engines/gameEngine";
import NodeUtil from "../../../engines/libs/NodeUtil";
import utilsModel from "../../../engines/libs/utilsModel";
import utilsView from "../../../engines/libs/utilsView";
import { FileKind } from "../../../modes/define/FileKind";
import ModelDialogLayer from "../../../modes/gameCommon/basic/ModelDialogLayer";
import { BUNDLE_SMALL_NAME } from "../../../modes/normalMode/BundleResourceConfig";
import NormalGameManager from "../../../modes/normalMode/manager/NormalGameManager";
import HelpWifeLayer1Tools from "./HelpWifeLayer1Tools";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HelpWifeLayer2 extends BasePopUpLayer {

    @property(cc.Node)
    nodeHint: cc.Node = null;
    @property(cc.Node)
    nodeAd: cc.Node = null;

    @property(cc.Node)
    nodeStep0: cc.Node = null;
    @property(cc.Node)
    nodeStep1: cc.Node = null;
    @property(cc.Node)
    nodeStep2: cc.Node = null;
    @property(cc.Node)
    nodeStep3: cc.Node = null;
    @property(cc.Node)
    nodeStep4: cc.Node = null;
    @property(cc.Node)
    nodeStepArea0: cc.Node = null;

    @property(cc.Node)
    nodeTools: cc.Node = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    private bShowHint = false;
    private touchNode: cc.Node = null;
    private oriPos: cc.Vec2 = null;

    private curStep = 0;
    private stepStateList: boolean[] = [];

    private soundId:number = null;

    private errorCount = 0;

    private bStep3Start = false;

    start () {
        this.refreshHintState();

        this.nodeTools.children.forEach((v)=> {
            let sprItem = v.getChildByName('sprItem');
            sprItem.on(cc.Node.EventType.TOUCH_START,this.onTouchStart,this);
            sprItem.on(cc.Node.EventType.TOUCH_MOVE,this.onTouchMove,this);
            sprItem.on(cc.Node.EventType.TOUCH_END,this.onTouchEnd,this);
            sprItem.on(cc.Node.EventType.TOUCH_CANCEL,this.onTouchEnd,this);
        });

        this.node.on(cc.Node.EventType.TOUCH_START,this.step3Start,this);
        this.node.on(cc.Node.EventType.TOUCH_MOVE,this.step3Move,this);
        this.node.on(cc.Node.EventType.TOUCH_END,this.step3End,this);
        this.node.on(cc.Node.EventType.TOUCH_CANCEL,this.step3End,this);
        
    }

    offToolsTouchEventAll() {
        this.nodeTools.children.forEach((v)=> {
            let sprItem = v.getChildByName('sprItem');
            sprItem.off(cc.Node.EventType.TOUCH_START,this.onTouchStart,this);
            sprItem.off(cc.Node.EventType.TOUCH_MOVE,this.onTouchMove,this);
            sprItem.off(cc.Node.EventType.TOUCH_END,this.onTouchEnd,this);
            sprItem.off(cc.Node.EventType.TOUCH_CANCEL,this.onTouchEnd,this);
        });
    }


    offToolsTouchEvent(node: cc.Node) {
        node.off(cc.Node.EventType.TOUCH_START,this.onTouchStart,this);
        node.off(cc.Node.EventType.TOUCH_MOVE,this.onTouchMove,this);
        node.off(cc.Node.EventType.TOUCH_END,this.onTouchEnd,this);
        node.off(cc.Node.EventType.TOUCH_CANCEL,this.onTouchEnd,this);
    }

    onTouchStart(event: cc.Event.EventTouch) {
        let curNode = event.getCurrentTarget();
        if (this.touchNode && this.touchNode != curNode) {
            return;
        }
        this.touchNode = curNode;
        curNode.parent.zIndex = 1;
        this.oriPos = curNode.getPosition().clone();
        this.stopSound();
        let state1 = curNode.getChildByName('state1');
        let state0 = curNode.getChildByName('state0');
        state0.active = false;
        state1.active = true;
    }

    stopSound() {
        if(this.soundId != null){
            O1HD.getManagers().soundMgr.stopSound(this.soundId);
            this.soundId = null;
        }
    }

    onTouchMove(event: cc.Event.EventTouch) {
        if (!this.touchNode) {
            return;
        }
        let node = event.getCurrentTarget();
        if (this.touchNode && this.touchNode != node) {
            return;
        }
        let delta:cc.Vec2 = event.getDelta();
        node.x += delta.x;
        node.y += delta.y;

        let bBack = false;
        let nodeTrigger = node.getChildByName('nodeTrigger');
        let script = node.getComponent(HelpWifeLayer1Tools);
        let bCollide = NodeUtil.areNodesOverlap(this.nodeStepArea0, nodeTrigger);
        switch(script.tag) {
            case 0: {
                let state1 = node.getChildByName('state1');
                let state2 = node.getChildByName('state2');
                if (bCollide) {
                    if (this.curStep != 0) {
                        bBack = true;
                        break;
                    }   
                    this.errorCount = 0;
                    state2.active = true;
                    state1.active = false;
                    if (!this.stepStateList[0]) {
                        this.nodeStep1.active = true;
                        this.nodeStep2.active = true;
                        this.nodeStep1.opacity = 0;
                        cc.tween(this.nodeStep1)
                        .to(0.5, {opacity: 255})
                        .start();
                        cc.tween(this.nodeStep0)
                        .to(0.5, {opacity: 0})
                        .start();
                        this.stepStateList[0] = true;
                    }
                    if (this.soundId == null) {
                        this.soundId = 0;
                        O1HD.getManagers().soundMgr.playSound("healBeriberi_jiujingxi",null,null,true).then((id)=>{
                            this.soundId = id;
                        });
                    }
                } else {
                    state2.active = false;
                    state1.active = true;
                    this.stopSound();
                }
            }
            break;
            case 1: {
                let state1 = node.getChildByName('state1');
                let state2 = node.getChildByName('state2');
                state1.active = false;
                state2.active = true;
                if (bCollide) {
                    if (this.curStep != 1) {
                        bBack = true;
                        break;
                    }
                    this.errorCount = 0;
                    // state2.active = true;
                    // state1.active = false;
                    this.plasterCheck(node, nodeTrigger.convertToWorldSpaceAR(cc.v2()));

                    if (this.soundId == null) {
                        this.soundId = 0;
                        O1HD.getManagers().soundMgr.playSound("healBeriberi_jiaoqiling",null,null,true).then((id)=>{
                            this.soundId = id;
                        });
                    }
                } else {
                    // state2.active = false;
                    // state1.active = true;
                    this.stopSound();
                }
                
            }
            break;
            case 3: {
                if (bCollide) {
                    if (this.curStep != 3) {
                        bBack = true;
                        break;
                    }
                    this.errorCount = 0;

                    if (!this.stepStateList[3]) {
                       
                        this.stepStateList[3] = true;
                    }
                }
            }
            break;
        }

        if (bBack) {
            this.errorCount++;
            this.stopSound();
            O1HD.getManagers().soundMgr.playSound("healBeriberi_error");
            this.backOriPos(node);

            if (this.errorCount >= 2) {
                this.gameLose();
            }
        }
    }

    onTouchEnd(event: cc.Event.EventTouch) {
        if (!this.touchNode) {
            return;
        }
        let node = event.getCurrentTarget();
        if (this.touchNode && this.touchNode != node) {
            return;
        }
        this.stopSound();
        let script = node.getComponent(HelpWifeLayer1Tools);

        switch(script.tag) {
            case 0: {
                if (this.stepStateList[0]) {
                    // node.active = false;
                    this.curStep = 1;
                }
            }
            break;
            case 1: {
                if (this.stepStateList[1]) {
                    this.curStep = 2;
                    this.nodeStep3.active = true;
                }
            }
            break;
            case 3: {
                if (this.stepStateList[3]) {
                    O1HD.getManagers().soundMgr.playSound("healBeriberi_shabu");
                    this.nodeStep4.active = true;
                    this.nodeStep4.opacity = 0;
                    cc.tween(this.nodeStep4)
                    .to(0.5, {opacity: 255})
                    .start();
                    this.offToolsTouchEventAll();
                    this.gameWin();
                }
            }
            break;
        }
        
        this.backOriPos(node);
       
    }

    backOriPos(node: cc.Node) {
        let state1 = node.getChildByName('state1');
        let state2 = node.getChildByName('state2');
        let state0 = node.getChildByName('state0');
        state0.active = true;
        state1.active = false;
        state2 && (state2.active = false);

        cc.tween(node)
        .to(0.35, {x: this.oriPos.x, y: this.oriPos.y})
        .call(()=> {
            node.parent.zIndex = 0;
        })
        .start();
        
        this.touchNode = null;
        this.oriPos = null;
    }

    refreshHintState() {
        this.nodeHint.active = this.bShowHint;
        this.nodeAd.active = !this.bShowHint;
    }

    step3Start() {
        if (this.touchNode) {
            return;
        }
        if (this.curStep != 2) {
            return;
        }  
        this.bStep3Start = true;
    }

    step3End() {
        this.bStep3Start = false;
    }

    step3Move(event: cc.Event.EventTouch) {
        if (!this.bStep3Start) {
            return;
        }  
        this.plasterFloatingCheck(event.getLocation());
    }

    plasterFloatingCheck(nodePos: cc.Vec2) {

        this.plasterCheck(null, nodePos, false);
        const g_range = 30;   
        let nodeStep = this.nodeStep3;
        let maskNode = nodeStep.getComponent(cc.Mask);
        let pos :cc.Vec2 = nodeStep.convertToNodeSpaceAR(nodePos);
        // @ts-ignore
        maskNode._graphics.fillColor = cc.Color.WHITE;
        // @ts-ignore
        maskNode._graphics.strokeColor = cc.Color.WHITE;
        // @ts-ignore
        maskNode._graphics.circle (pos.x,pos.y, g_range )
        // @ts-ignore
        maskNode._graphics.fill();
        // @ts-ignore
        maskNode._graphics.stroke();

        let rect = cc.rect(pos.x - g_range, pos.y - g_range, g_range*2, g_range*2);
        let nodeTrigger = nodeStep.getChildByName('nodeTrigger');

        for (let i = nodeTrigger.children.length-1; i >= 0; i--) {
            let n = nodeTrigger.children[i];
            if (rect.contains(n.getPosition())) {
                n.destroy();
                nodeTrigger.children.splice(i, 1);
            }
        }
        if (nodeTrigger.children.length <= 0) {
            // 完成步骤
            this.touchNode = null;
            this.oriPos = null;
            this.curStep = 3;
            this.stepStateList[2] = true;
            
            this.nodeStep2.active = false;
            // @ts-ignore
            maskNode._graphics.clear();
            maskNode.inverted = true;
        }
 
    }

    plasterCheck(node: cc.Node, nodePos: cc.Vec2, bTirgger: boolean = true){     
        const g_range = 30;   
        let maskNode = this.nodeStep2.getComponent(cc.Mask);
        let pos :cc.Vec2 = this.nodeStep2.convertToNodeSpaceAR(nodePos);
        // @ts-ignore
        maskNode._graphics.fillColor = cc.Color.WHITE;
        // @ts-ignore
        maskNode._graphics.strokeColor = cc.Color.WHITE;
        // @ts-ignore
        maskNode._graphics.circle (pos.x,pos.y, g_range )
        // @ts-ignore
        maskNode._graphics.fill();
        // @ts-ignore
        maskNode._graphics.stroke();

        if (!bTirgger) {
            return;
        }
        let rect = cc.rect(pos.x - g_range, pos.y - g_range, g_range*2, g_range*2);
        let nodeTrigger = this.nodeStep2.getChildByName('nodeTrigger');

        for (let i = nodeTrigger.children.length-1; i >= 0; i--) {
            let n = nodeTrigger.children[i];
            if (rect.contains(n.getPosition())) {
                n.destroy();
                nodeTrigger.children.splice(i, 1);
            }
        }
        if (nodeTrigger.children.length <= 0) {
            // 完成步骤
            // @ts-ignore
            maskNode._graphics.clear();
            maskNode.inverted = true;
            this.stepStateList[1] = true;
        }
    }

    gameLose() {
        this.offToolsTouchEventAll();

        ModelDialogLayer.show('因为你操作不当，老婆当场晕倒，你花费1个亿才抢救回来', ()=> {
            O1HD.getServices().userSrv.setCoins(-100000000,true);
            this.destroyNode();
        }, ()=> {
            this.destroyNode();
            utilsView.openPopupLayer(
                'helpWife/prefab/HelpWifeLayer2'
                , BUNDLE_SMALL_NAME.waterCourse
            );
        }
        , '挽回损失'
        , '离开'
        , true
        , null
        , '救老婆挽回损失'
        );
    }

    openLayer3() {

        let gameData = NormalGameManager._instance.getGameData();
        gameData.bFinishHelpWife = true;
        NormalGameManager._instance.writeGameData();

        utilsView.openPopupLayer(
            'helpWife/prefab/HelpWifeLayer3'
            , BUNDLE_SMALL_NAME.waterCourse
            , null
            , null
            , null
            , (node)=> {
                cc.tween(this.node)
                .to(0.55, {opacity: 0})
                .call(()=> {
                    this.destroyNode();
                })
                .start();
                node.opacity = 0;
                cc.tween(node)
                .to(0.55, {opacity: 255})
                .start();
            }
        );
    }

    gameWin() {
        cc.tween(this.node)
        .delay(2)
        .call(this.openLayer3.bind(this))
        .start();
    }

    onClickHint() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (this.bShowHint) {
            this.openHint();
        } else {
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.bShowHint = true;
                this.openHint();
                this.refreshHintState();
            },()=>{
     
            }, null, "救老婆看广告获得提示");
        }
    }

    openHint() {
        utilsView.openPopupLayer(
            'helpWife/prefab/HelpWifeHint'
            , BUNDLE_SMALL_NAME.waterCourse
            , this.node
            , {
                bHint1: false
            }
        );
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
